export default __webpack_public_path__ + "static/media/14.dd48aed9.jpg";